// extracted by mini-css-extract-plugin
export default {"error-component-wrapper":"DefaultErrorComponent_error-component-wrapper__KS7Lm"};